<!--
    课程中心-课程购买
    功能：课程购买
    说明：旧版本
-->
<template>
  <div class="detail" v-loading="dialogCheck.loading">
    <el-link
      class="app-webview-back"
      :underline="false"
      @click="$router.go(-1)"
    >
      <i class="el-icon-arrow-left"/>
      返回
    </el-link>

    <dl class="detail-head flex">
      <dt v-if="list.video" class="fn pr" @click="showVideo(list.name, list.video)">
        <img :src="list.cover || noCover">
        <div class="btn-video"></div>
      </dt>
      <dt v-else class="fn pr">
        <img :src="list.cover || noCover">
      </dt>
      <dd class="fg">
        <h3>{{list.name}}</h3>
        <div class="flex jb w600">
          <div class="flex"><span class="gray">制作方：</span><p class="elps">{{ detail.company_name }}</p></div>
          <p><span class="gray">上线时间：</span>{{list.publish_time}}</p>
          <p><span class="gray">课时数量：</span>{{list.course_count}}课时</p>
        </div>
        <dl class="head-price iflex ac ja">
          <dd>
            <p class="gray">线下课时单价（/课时/次）</p>
            <div class="flex jb">
              <div><span>原价：</span>{{list.offline_price}}金币</div>
              <p class="flex"><span class="gray">优惠价：</span><strong>{{list.offline_discount_price}}金币</strong></p>
            </div>
          </dd>
          <dt></dt>
          <dd>
            <p class="gray">线上课时单价（/课时/学生/次）</p>
            <div class="flex jb">
              <div><span>原价：</span>{{list.online_price}}金币</div>
              <p class="flex"><span class="gray">优惠价：</span><strong>{{list.online_discount_price}}金币</strong></p>
            </div>
          </dd>
        </dl>
      </dd>
    </dl>

    <div class="class-line">
      <div class="line-item">
        <p>线下次课（/课时/次）：<span>(课程包内任意一个课时允许XX次/XX课时各上1次的线下白板课费用)</span></p>
        <div class="my-input-number iflex">
          <el-button class="flex ac jc" @click="countMinus('off')" :disabled="offline_num == offline_min">
            <i class="el-icon-minus"/>
          </el-button>
          <input v-model="offline_num" type="text" @change="countPrice('off')">
          <el-button class="flex ac jc" @click="countPlus('off')" :disabled="offline_num == maxLine">
            <i class="el-icon-plus"/>
          </el-button>
        </div>
      </div>
      <div class="line-item">
        <p>线上次课（/课时/学生/次）：<span>(课程包内任意一个课时允许同时XX学生上1次线上课的课件费用)</span></p>
        <div class="my-input-number iflex">
          <el-button class="flex ac jc" @click="countMinus('on')" :disabled="online_num == online_min">
            <i class="el-icon-minus"/>
          </el-button>
          <input v-model="online_num" type="text" @change="countPrice('on')">
          <el-button class="flex ac jc" @click="countPlus('on')" :disabled="online_num == maxLine">
            <i class="el-icon-plus"/>
          </el-button>
        </div>
      </div>
      <div class="line-price flex">
        <span class="gray">原总价：</span>
        {{price_all}}金币
      </div>
      <div class="line-price flex">
        <span class="gray">优惠总价：</span>
        <span class="red">{{price_discount}}金币</span>
      </div>
    </div>

    <div class="detail-foot flex jc">
      <el-button type="primary" @click="classBuy">确认订单并支付</el-button>
    </div>

    <el-dialog
      :title="videoData.title"
      class="dialog-sp1 dialog-video"
      :visible.sync="videoData.show"
      @opened="videoOpen"
      @close="videoClose"
      width="692px">
      <video ref="ref_video" :src="videoData.src" controls="controls" width="100%"></video>
    </el-dialog>

    <el-dialog
      title="支付确认"
      class="dialog-sp1 dialog-success dialog-check"
      :visible.sync="dialogCheck.show"
      @close="watchClear"
      width="420px">
      <div class="check-tip flex ac">{{dialogCheck.data.prompt}}</div>
      <div class="check-con">
        <p class="flex ac jb">
          <span class="gray">总所需支付：</span>
          <span>{{dialogCheck.data.coin_need}}金币</span>
        </p>
        <p class="flex ac jb">
          <span class="gray">套餐剩余金币抵扣：</span>
          <span>{{dialogCheck.data.coin_paid}}金币</span>
        </p>
        <p class="flex ac jb">
          <span class="gray">还需支付金币：</span>
          <span>{{dialogCheck.data.cash_pay}}金币</span>
        </p>
        <p class="flex ac jb">
          <span class="gray">现金支付：</span>
          <span class="red">{{dialogCheck.data.cash_pay}}元</span>
        </p>
      </div>
      <div class="check-img">
        <el-button @click="getCover" type="primary">去支付</el-button>
<!--        <img :src="dialogCheck.data.recharge.code_img_url">-->
      </div>
    </el-dialog>

    <el-dialog
      title="支付确认"
      class="dialog-sp1 dialog-success"
      :visible.sync="successDialog"
      width="288px">
      <div class="dialog-success-icon flex ac jc">
        <i></i>
        完成支付
      </div>
      <div class="flex jc">
        <el-button type="primary" @click="routerMyClass">确认并跳转{{$store.state.from === 'schoolCenter' ? '已购课程' : '我的课程'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import index from './';
  export default index;
</script>

<style scoped lang="scss">
  @import '../../../assets/reset.scss';
  @import "../ClassDetail/index.scss";
  @import "index.scss";

  .dialog-success-icon i {
    background: url(assets/success.png);
  }
</style>



// WEBPACK FOOTER //
// src/views/Goods/ClassBuy/index.vue